import { useEffect, useState } from 'react'

import { Input } from '@/components/ui/input'
import { cn } from '@/lib/utils'

type Props = {
  label: string
  value: string
  onCommit: (value: string) => void
  /** 人が直したフィールドは印を付けて、AIの抽出値と区別できるようにする */
  isEdited?: boolean
  type?: 'text' | 'number' | 'datetime-local'
  className?: string
}

/**
 * フォーカスを外したとき（または Enter）に確定して親へ通知する入力欄。
 *
 * 入力のたびに PATCH が飛ぶと編集途中の値まで保存されてしまうため、確定操作をまとめている。
 */
export const EditableField = ({ label, value, onCommit, isEdited, type = 'text', className }: Props) => {
  const [draft, setDraft] = useState(value)

  // 他の操作（AI候補の採用など）で外側の値が変わったら追従する
  useEffect(() => {
    setDraft(value)
  }, [value])

  const commit = () => {
    if (draft === value) return
    onCommit(draft)
  }

  return (
    <label className={cn('flex flex-col gap-1', className)}>
      <span className="text-xs text-muted-foreground">
        {label}
        {isEdited && <span className="ml-1 text-primary">(修正済み)</span>}
      </span>
      <Input
        type={type}
        value={draft}
        onChange={(event) => setDraft(event.target.value)}
        onBlur={commit}
        onKeyDown={(event) => {
          if (event.key !== 'Enter') return
          event.currentTarget.blur()
        }}
      />
    </label>
  )
}
